export interface Teaser {
  header: string;
  headerMobile: string;
  ident: string;
  image: {
    original: string;
    path: string;
    backgroundPosition: string;
    alt: string;
  };
  imageMobile: {
    original: string;
    path: string;
    backgroundPosition: string;
    alt: string;
  };
  text: string;
  textMobile: string;
}

export function isTeaser(teaser: Teaser | []): teaser is Teaser {
  return (teaser as Teaser).image !== undefined;
}
